import { getHomePageUrl } from 'utils/navigation';

export const applicationsPageBreadcrumbs = (): any => [
  {
    href: getHomePageUrl(),
    label: 'Начало'
  }
];
